import {
  ArrayInput,
  BooleanInput,
  Edit,
  ListButton,
  required,
  SaveButton,
  SelectInput,
  ShowButton,
  SimpleFormIterator,
  TabbedForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const LandingsEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <TabbedForm toolbar={<EditToolbar />}>
      <TabbedForm.Tab label="Landing">
        <TextInput
          source="title"
          label="Landing Title:"
          validate={required()}
        />
        <TextInput
          source="appLandingId"
          label="App Landing ID:"
          validate={required()}
        />
        <BooleanInput
          source="showAcceptPrivacy"
          label="Show Accept Privacy:"
          validate={required()}
        />
        <TextField source="createdAt" label="СreatedAt:" />
        <TextField source="updatedAt" label="UpdatedAt:" />
      </TabbedForm.Tab>

      <TabbedForm.Tab label="Attributes">
        <ArrayInput source="attributes">
          <SimpleFormIterator inline>
            <SelectInput
              source="groupName"
              label="Group Name:"
              choices={[{ id: "subscription", name: "subscription" }]}
              defaultValue="subscription"
            />
            <TextInput source="content" label="Content:" />
          </SimpleFormIterator>
        </ArrayInput>
      </TabbedForm.Tab>
    </TabbedForm>
  </Edit>
);
